var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"view-glowtext"},_vm._l((_vm.characters),function(character,index){return _c('span',{key:index,staticClass:"color-gold",style:({
			filter: `blur(${_vm.getBlurAmount(index)}px)`,
			textShadow: `0 0 ${_vm.getShadowAmount(index)}px var(--color-global-gold)`,
		})},[_vm._v(" "+_vm._s(character)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }